module.exports = __webpack_public_path__ + "img/medalha-economia-criativa.42bd7ed7.jpeg";